import { DateTime } from 'luxon'
import { SkillType, SkillTypeDto, skillTypeFromDto } from './skillType'
import z from 'zod'

export const SkillID = z.string().brand<'SkillID'>()
export type SkillID = z.infer<typeof SkillID>

export interface SkillJson {
    id: string
    name: string
    code: string
    created_at: string | null
    updated_at: string | null
    archived_at: string | null

    permissions: { can_edit: boolean }

    type?: {
        data: SkillTypeDto
    }
}

export interface Skill {
    id: SkillID
    name: string
    code: string
    createdAt: DateTime | null
    updatedAt: DateTime | null
    archivedAt: DateTime | null

    type: SkillType | null
}


export const createSkill = (
    params: {
        id: SkillID,
        name: string,
        code: string,
        createdAt?: DateTime | null,
        updatedAt?: DateTime | null,
        archivedAt?: DateTime | null,

        type?: SkillType | null,
    }
): Skill => ({
    id: params.id,
    name: params.name,
    code: params.code,
    createdAt: params.createdAt ?? null,
    updatedAt: params.updatedAt ?? null,
    archivedAt: params.archivedAt ?? null,
    type: params.type ?? null,
})

export const skillFromDto = (dto: SkillJson): Skill => (createSkill({
    id: dto.id as SkillID,
    name: dto.name,
    code: dto.code,
    createdAt: dto.created_at ? DateTime.fromISO(dto.created_at) : null,
    updatedAt: dto.updated_at ? DateTime.fromISO(dto.updated_at) : null,
    archivedAt: dto.archived_at ? DateTime.fromISO(dto.archived_at) : null,

    type: dto.type?.data ? skillTypeFromDto(dto.type.data) : null,
}))
